import { syncPostHogIdentityAfterSession } from '@hookdeck/analytics';

import { User } from '../../../../typings/User.interface';
import HookdeckAPI from '../client/Hookdeck';

type HookdeckSessionClient = Pick<HookdeckAPI, 'session'>;

/**
 * Link anonymous sign-in/sign-up page events to the authenticated user, then navigate.
 * Must run before `window.location` assignment so PostHog still has the page's anon id.
 */
export const completeAuthRedirect = async (
  hookdeck_api: HookdeckSessionClient,
  env: string,
  redirect_url?: string,
): Promise<void> => {
  const posthog = (window as { posthog?: Parameters<typeof syncPostHogIdentityAfterSession>[0] })
    .posthog;

  await syncPostHogIdentityAfterSession(posthog, () => hookdeck_api.session.me() as Promise<User>, {
    env,
  });

  (window as any).location = redirect_url || '/';
};
